import { render, staticRenderFns } from "./Schedule.vue?vue&type=template&id=c252b7f0&scoped=true"
import script from "./Schedule.vue?vue&type=script&lang=js"
export * from "./Schedule.vue?vue&type=script&lang=js"
import style0 from "./Schedule.vue?vue&type=style&index=0&id=c252b7f0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c252b7f0",
  null
  
)

export default component.exports